import { Route } from 'react-router-dom';

export function ApplicationsMyRoutes() {
    return (
        <Route path='my'>
            <Route
                path='send_dirty_laundry'
                element={
                    <div>
                        <h1>Send Dirty Laundry</h1>
                        <p>This is a placeholder for the send dirty laundry component.</p>
                    </div>
                }
            />
        </Route>
    );
}
